"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureExists = void 0;
var ensureExists = function (item, msg) {
    if (typeof item === 'undefined' || item === null) {
        throw (msg || 'Variable is null or undefined');
    }
    return item;
};
exports.ensureExists = ensureExists;
//# sourceMappingURL=index.js.map